module.exports = __webpack_public_path__ + "img/w3_outlet_black.a5e5ce09.png";